import React, { Component } from "react";

import { Row, Card, Col, Button, Form } from "reactstrap";
import Calendar from "./datepicker";
import * as common from "../Common/common";

class newFertilization extends Component {
  state = {
    year: -1,
    month: -1,
    day: -1,
    cropName: "",
  };
  onChangeCalender = (event, ymd) => {
    this.setState({ [event.target.name]: parseInt(event.target.value) });
  };
  render() {
    const { crops } = this.props;
    var button_style =
      this.state.year !== -1 && this.state.month !== -1 && this.state.day !== -1
        ? { disable: false }
        : { disable: true };
    return (
      <Row>
        <Col md={8} sm={12} xs={12}>
          <Card body id="cropNew">
            <Form>
              {crops && (
                <Calendar
                  year={{
                    min: this.props.cropRotations.min_year,
                    max: this.props.cropRotations.max_year,
                  }}
                  ymd={this.state}
                  onChangeCalender={this.onChangeCalender.bind(this)}
                  name={common.setCropName(this.state, this.props.crops.crops)}
                  monthday={common.monthday}
                />
              )}
              <Button
                color="warning"
                onClick={(e) => this.props.create(e, this.state)}
                disabled={button_style.disable}
              >
                新しい施肥を追加
              </Button>
            </Form>
          </Card>
        </Col>
      </Row>
    );
  }
}

export default newFertilization;
